// extracted by mini-css-extract-plugin
export const plans = "PricingView-module--plans--gnqDg";